import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { RESEARCH } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/research/new")({
  component: () => <DeptContentForm cfg={RESEARCH} />,
});
